<mat-toolbar color="accent">
  {{ data ? 'Edit' : 'Add' }} Treatment Category
</mat-toolbar>

<form [formGroup]="categoryForm" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column">
    <mat-form-field fxFlex>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" [required]="true" />
    </mat-form-field>
    <pt-display-colour-picker
      fxFlex
      label="Category Colour"
      formControlName="colour"
      [options]="colourOptions"
     />
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button mat-stroked-button mat-dialog-close type="button">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="categoryForm.invalid">
        Save
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
